import { render, staticRenderFns } from "./ModernActivationReceipt.vue?vue&type=template&id=a612ca24&scoped=true"
import script from "./ModernActivationReceipt.vue?vue&type=script&lang=js"
export * from "./ModernActivationReceipt.vue?vue&type=script&lang=js"
import style0 from "./ModernActivationReceipt.vue?vue&type=style&index=0&id=a612ca24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a612ca24",
  null
  
)

export default component.exports